import {
  BarGraphIcon,
  ChatsIcon,
  ComputerIcon,
  DashboardIcon,
  FacebookIcon,
  GoogleIcon,
  ListIcon,
  MegaphoneIcon,
  MetaIcon,
  MobileIcon,
  PlayIcon,
  ShieldIcon,
  SocialIconCombined,
  TabletIcon,
  TikTokIcon,
  TreeIcon,
} from "../components/Icons";
import routeConstants from "./routeConstants";

export const dataSourceList = [
  { name: "Google", key: "google", icon: GoogleIcon, isConnected: false },
  { name: "Meta", key: "facebook", icon: MetaIcon, isConnected: false },
  { name: "TikTok", key: "tiktok", icon: TikTokIcon, isConnected: false },
];

export const campaignHeaderOptions = [
  {
    label: "All Platform",
    value: "All",
  },
  {
    icon: GoogleIcon,
    label: "Google Ads",
    value: "google",
  },
  {
    icon: MetaIcon,
    label: "Meta Ads",
    value: "meta",
  },
  {
    icon: TikTokIcon,
    label: "TikTok",
    value: "tiktok",
  },
];

export const campaignHeaderStatusOptions = [
  {
    label: "All Status",
    value: "All",
  },
  {
    label: "Active",
    value: "ACTIVE",
  },
  {
    label: "Paused",
    value: "PAUSED",
  },
];

export const insightHeaderGroupByOptions = [
  {
    label: "Group by Ads",
    value: "source_ad_id",
  },
  {
    label: "Group by Campaigns",
    value: "source_campaign_id",
  },
];

export const adVisitorDeviceData = [
  {
    name: "Mobile Phones",
    percentage: 25,
    color: "#20407D",
    icon: MobileIcon,
  },
  {
    name: "Tablets",
    percentage: 55,
    color: "#4B73B8",
    icon: TabletIcon,
  },
  {
    name: "Computers",
    percentage: 20,
    color: "#8D9DD0",
    icon: ComputerIcon,
  },
];

export const metricsData = [
  {
    "Trial Partner Metrics": ["Click score", "Convert score"],
  },
  {
    Performance: [
      "Average order value",
      "Reach",
      "Impressions",
      "Cost per mille",
      "Spend",
    ],
  },
];

export const reportsStepOneSocialMediaOptions = [
  { name: "All", icon: SocialIconCombined },
  { name: "Google", icon: GoogleIcon },
  { name: "Meta", icon: MetaIcon },
  { name: "Tiktok", icon: TikTokIcon },
];

export const reportStepperTitleAndSubtitle = [
  {
    title: "Select Platform",
    subtitle:
      "Choose the platform(s) for which you want to generate ad reports and insights.",
  },
  {
    title: "Select Google Campaign",
    subtitle:
      "Kindly choose the campaigns for which you wish to generate a report.",
  },
  {
    title: "Select Metrics",
    subtitle:
      "Choose the performance metrics you want to include in your report. These insights will help analyze your campaign effectiveness.",
  },
  {
    title: "Select Date Range",
    subtitle:
      "Pick a start and end date to define the reporting period for your selected campaigns and metrics.",
  },
];

export const campaignFilterOptions = [
  {
    title: "Campaign",
  },
  {
    title: "Conversions",
  },
  {
    title: "Reports",
  },
];

export const dateFilterOptions = [
  {
    title: "Last 30 days",
    value: "Last 30 days",
  },
  {
    title: "Last 15 days",
    value: "Last 15 days",
  },
  {
    title: "Last 7 days",
    value: "Last 7 days",
  },
];

export const sidebarItems = [
  {
    icon: DashboardIcon,
    label: "Dashboard",
    link: routeConstants.dashboard,
    paths: [routeConstants.dashboard],
  },
  {
    icon: ListIcon,
    label: "Sign Up Forms",
    link: routeConstants.conversions,
    paths: [
      routeConstants.conversions,
      routeConstants.conversionsAddForm,
      routeConstants.conversionsUpdateForm + "/:id",
      routeConstants.conversionAccountDetails + "/:id",
      routeConstants.conversionDetails + "/:id",
    ],
  },
  {
    icon: MegaphoneIcon,
    label: "Campaigns",
    link: routeConstants.campaigns,
    paths: [routeConstants.campaigns, routeConstants.campaignDetails + "/:id"],
  },
  {
    icon: PlayIcon,
    label: "Ad Creatives",
    link: routeConstants.adCopies,
    paths: [routeConstants.adCopies],
  },
  {
    icon: TreeIcon,
    label: "Manage Data Sources",
    link: routeConstants.manageDataSource,
    paths: [routeConstants.manageDataSource],
  },
  {
    icon: BarGraphIcon,
    label: "Reports",
    link: routeConstants.reports,
    paths: [
      routeConstants.reports,
      routeConstants.generateReports,
      routeConstants.generatedReport + "/:id",
      routeConstants.topRecommendedDetailsReport + "/:id",
    ],
  },
  {
    icon: ChatsIcon,
    label: "Send Feedback",
    link: routeConstants.sendFeedback,
    paths: [routeConstants.sendFeedback],
  },
  {
    icon: ShieldIcon,
    label: "Privacy Policy",
    link: routeConstants.privacyPolicy,
    paths: [routeConstants.privacyPolicy],
  },
];

export const learnAboutUsItems = [
  {
    title: "How to manage data sources ?",
    thumbnail: require("../assets/Rectangle1.png"),
  },
  {
    title: "How to generate Report ?",
    thumbnail: require("../assets/Rectangle1.png"),
  },
  {
    title: "How to add role from Manage Members ?",
    thumbnail: require("../assets/Rectangle1.png"),
  },
  {
    title: "How to manage data sources ?",
    thumbnail: require("../assets/Rectangle1.png"),
  },
  {
    title: "How to add role from Manage Members ?",
    thumbnail: require("../assets/Rectangle1.png"),
  },
  {
    title: "How to generate Report ?",
    thumbnail: require("../assets/Rectangle1.png"),
  },
];
